import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[numeric]'
})

export class NumericDirective {

    static parameters = [ElementRef];

    @Input('numericType') numericType: string; // number | decimal | percent
    @Input('numericDigit') numericDigit: Number = 2; // number | decimal | percent

    private regex = {
        number: new RegExp(/^\d+$/),
        decimal: new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g),
        percent: new RegExp(/^\d{0,2}\.?\d{0,2}$/g)
    };

    private specialKeys = {
        number: [ 'Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight' ],
        decimal: [ 'Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight' ],
        percent: [ 'Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight' ],
    };

    constructor(private el: ElementRef) {
    }

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyboardEvent) {

        if (this.specialKeys[this.numericType].indexOf(event.key) !== -1) {
            return;
        }
        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        let next: string = '';
        if(this.numericType == "percent") {
            if(!(this.el.nativeElement.selectionStart == this.el.nativeElement.selectionEnd)){
                current = "";
            }
            next = [ current.slice(0, position), event.key == "Decimal" ? "." : event.key, current.slice(position)].join("");
            const beforeDecimal: any = next.split(".")[0];
            const AfterDecimal: any = next.split(".")[1];
            const checkDotFirstPosition: string = next.substring(0, 1);
            if (next === "00") {
                event.preventDefault();
            }
            if (checkDotFirstPosition === ".") {
                // event.preventDefault();
                current = "0";
                this.el.nativeElement.value = "0";
            }
            if (beforeDecimal) {
                if (beforeDecimal <= 100) {
                    if (beforeDecimal.toString().length >= 4) {
                        event.preventDefault();
                    }
                } else {
                    if (beforeDecimal.toString().length >= 3) {
                        event.preventDefault();
                    }
                }
            }
            if (AfterDecimal) {
                if (AfterDecimal.toString().length >= 3) {
                    event.preventDefault();
                }
            }
            if (next && !String(next).match(this.regex[this.numericType])) {
                event.preventDefault();
            }
        } else {            
            next = [current.slice(0, position), event.key, current.slice(position)].join("");
            if (next) {
                var SplitNumeric = next.split('.');
                if(!String(next).match(this.regex[this.numericType]) || (SplitNumeric.length > 1 && SplitNumeric[1].length > this.numericDigit)) {
                    event.preventDefault();
                }
            }
        }
    }
}